import React from 'react';
import './Tutor.css';

function Tutor() {
  return (
    <div id="quem-somos" className="app-tutor w-full grid justify-items-center">
        <div className="section">
            <div className="grid max-sm:grid-rows-2 h-[100vh] md:h-[50vh] md:grid-cols-2 place-content-evenly gap-2">
                <div className="app-tutor-img-01 h-full w-full md:h-[50vh] md:w-full" />

                <div className="grid pl-8 pr-8 md:h-full content-center justify-items-start">
                    <div className="font-bold text-2xl pb-4">
                        Wil Machado
                    </div>
                    <div className="text-xl md:text-left md:w-4/5">
                        Wil é poliglota, tutor de idiomas, advogado e criador do Destino Poliglota. 
                        Já viajou para 45 países e territórios e morou em 7 deles. 
                        Pesquisou em 5 países e concluiu seu Mestrado em Portugal.
                    </div>
                </div>
            </div>
            
            <div className="grid max-sm:grid-rows-2 h-[100vh] md:h-full md:grid-cols-2 place-content-evenly">
                <div className="app-tutor-img-02 h-full w-full md:h-[50vh] md:w-full md:order-last" />

                <div className="grid pl-8 pr-8 md:h-full content-center md:justify-items-end">
                    <div className="font-bold text-2xl pb-4">
                        Agustin Didia
                    </div>
                    <div className="text-xl md:text-right md:w-4/5">
                        Agustin é poliglota, tutor de idiomas, administrador e criador do Destino Poliglota. 
                        Já viajou para mais de 44 países e viveu em 5 deles. 
                        Concluiu seus estudos universitários nos Estados Unidos.
                    </div>
                </div>
            </div>
        </div>

        <div className="grid max-sm:grid-rows-2 h-full w-full md:h-[200px] md:grid-cols-2 
            place-content-evenly justify-items-center items-center bg-white pb-5 pt-5 md:pb-0">
            <div className="font-bold text-center text-4xl p-5 md:w-3/4">
                Entre em contato conosco. Venha conhecer o DP!
            </div>
            <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                hover:bg-gradient-to-br font-bold text-2xl font-bold rounded-4xl text-center cta">
                <a href="mailto:contato@destinopoliglota.com.br" target='_blank' rel='noopener noreferrer'>
                    Enviar e-mail</a>
            </button>
        </div>
    </div>
  );
}

export default Tutor;
